import {SemanticSearchAssistantPill} from "../../../semantic_search/components/SemanticSearchAssistantPill";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setAiAdvisorSpotlightSource} from "../../state/offer_listing_slice";

export const OfferListAiAssistantPill = () => {
    const dispatch = useAppDispatch();
    const isAiAdvisorSidebarAvailable = useAppSelector((state) => state.offerListing.isAiAdvisorSidebarAvailable);

    if (!isAiAdvisorSidebarAvailable) {
        return null;
    }

    return <SemanticSearchAssistantPill buttonCategory="listing_page" onClick={() => dispatch(setAiAdvisorSpotlightSource("searchPill"))} />;
};
import {SemanticSearchAssistantPill} from "../../../semantic_search/components/SemanticSearchAssistantPill";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setAiAdvisorSpotlightSource} from "../../state/offer_listing_slice";

export const OfferListAiAssistantPill = () => {
    const dispatch = useAppDispatch();
    const isAiAdvisorSidebarAvailable = useAppSelector((state) => state.offerListing.isAiAdvisorSidebarAvailable);

    if (!isAiAdvisorSidebarAvailable) {
        return null;
    }

    return <SemanticSearchAssistantPill buttonCategory="listing_page" onClick={() => dispatch(setAiAdvisorSpotlightSource("searchPill"))} />;
};
